import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import useGetVehicleInfo from "../../../store/selectors/get-vehicle-info";
import useGetCarPlan from "../../../store/selectors/get-car-plan-quote";
import useGetCarAddOn from "../../../store/selectors/get-car-add-on";
import useStoreCarAddOn from "../../../store/actions/store-car-add-on";
import useGetToken from "../../../store/selectors/get-token";

import useGetCarAddOnSelection from "../../../store/selectors/get-car-add-on-selection";
import useStoreCarAddOnSelection from "../../../store/actions/store-car-add-on-selection";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";

import {
	getMotorAddOns,
	getQuotes,
	getQuotesGen,
	getQuotesLib,
	getQuotesRhb,
	getQuotesSompo,
	getQuotesTmim,
	getQuotesIkhlas,
	viewPolicy,
	getQuotesEtiqa,
	getQuotesLonpac,
	getQuotesTuneProtect,
	getQuotesAllianz,
	getQuotesPoi,
	getQuotesGreatEastern,
	getQuotesTakafulMalaysia
} from "../../../utils/backend";
import { isPoiPlan, poiPlanFromQuote } from "../../../utils/poiQuote";
import { isGreatEasternPlan, greatEasternPlanFromQuote } from "../../../utils/greatEasternQuote";
import { isTakafulMalaysiaPlan, takafulMalaysiaPlanFromQuote } from "../../../utils/takafulMalaysiaQuote";

import "../../../assets/styles/add-on.css";
import "../../../assets/styles/sticky-bottom.css";
import useStoreCarPlan from "../../../store/actions/store-car-plan-quote";
import defaultIcon from "../../../assets/images/manual-quotation-default-icon.png";
import useGetOrderId from "../../../store/selectors/get-order-id";
import { getInsurerName } from "../../../utils/insurer-name";
import { useTranslation } from "react-i18next";

const InsuranceAddOns = () => {
	const location = useLocation();
	const selectedPlan = useGetCarPlan();
	const vehicleInfo = useGetVehicleInfo();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const token = useGetToken();

	const { t } = useTranslation();

	const [no_of_driver, setNoOfDriver] = useState(2);
	const [tmimQuoteAddOns, setTmimQuoteAddOns] = useState([]);

	const [selectedVariant, setSelectedVariant] = useState(() => {
		const cachedVariant = localStorage.getItem("selectedVariant");
		return cachedVariant ? JSON.parse(cachedVariant) : null;
	});

	const [roadTaxOption, setRoadTaxOption] = useState(() => {
		const cachedOption = localStorage.getItem("road_tax_option_api");
		return cachedOption ? cachedOption : "";
	});

	const defaultDrivers = [{ code: "01", name: vehicleInfo?.owner_name || "THE POLICY HOLDER" }];

	const [drivers, setDrivers] = useState(() => {
		const cachedDrivers = localStorage.getItem("drivers");
		return cachedDrivers ? JSON.parse(cachedDrivers) : [];
	});

	const [adddriver, setAddDriver] = useState(() => {
		const cachedDrivers = localStorage.getItem("adddriver");
		return cachedDrivers ? JSON.parse(cachedDrivers) : [];
	});

	const [allianzadddriver, setAllianzAddDriver] = useState(() => {
		const cachedDrivers = localStorage.getItem("allianz_adddriver");
		return cachedDrivers ? JSON.parse(cachedDrivers) : [];
	});

	const [lonpacCart, setLonpacCart] = useState(() => {
		const cachedCart = localStorage.getItem("cart_selection");
		return cachedCart ? JSON.parse(cachedCart) : {name: "CART 7 DAYS @ RM50.00/DAY", code: '7x50', si: "350", sum_insured: "350", unit: "7", amount: "50"};
	});

	const [lonpacWindscreenSI, setLonpacWindscreenSI] = useState(() => {
		const cachedCart = localStorage.getItem("M02_sum_insured");
		return cachedCart ? JSON.parse(cachedCart) : {name: "WINDSCREEN", si: "0", unit: "0.00"};
	});

	const [etiqaCart, setEtiqaCart] = useState(() => {
		const cachedCart = localStorage.getItem("etiqa_cart_selection");
		return cachedCart ? JSON.parse(cachedCart) : {name: "CART 7 DAYS @ RM50.00/DAY", code: 'P07A'};
	});

	const [etiqaLou, setEtiqaLou] = useState(() => {
		const cachedCart = localStorage.getItem("etiqa_lou_selection");
		return cachedCart ? JSON.parse(cachedCart) : { name: "Loss of Use (LOU) 10 Days x RM50/day", code: "P10A" }});

	const [etiqaD01A, setEtiqaD01A] = useState(() => {
		const cachedCart = localStorage.getItem("etiqa_d01a_selection");
		return cachedCart ? JSON.parse(cachedCart) : { name: "Car Re­-Spray Limit up to RM1,000", code: "D01A" }});

	const [sompoCart, setSompoCart] = useState(() => {
		const cachedCart = localStorage.getItem("sompo_cart_selection");
		return cachedCart ? JSON.parse(cachedCart) : {amount: "50", days: "7"};
	});

	const [allianzPAB3, setAllianzPAB3] = useState(() => {
		const cachedCart = localStorage.getItem("allianz_pab3_selection");
		return cachedCart ? JSON.parse(cachedCart) : {name: "Plan A - RM 25,000", code: "PAB3A"};
	});

	const [allianzPABERW, setAllianzPABERW] = useState(() => {
		const cachedCart = localStorage.getItem("allianz_paberw_selection");
		return cachedCart ? JSON.parse(cachedCart) : { name: "Plan A - 5 Days", code: "PABERWA"};
	});

	const [isRecon, setIsRecon] = useState(()=> {
		const cachedVariant = localStorage.getItem("isReconditioned");
		return cachedVariant ? Boolean(cachedVariant) : false;
	});

	const [addOns, setAddOns] = useState([]);
	const [addOnPrices, setAddOnPrices] = useState([]);
	const [selectedAddOns, setSelectedAddOns] = useState([]);

	const [loading, setLoading] = useState(false);
	const [quoteLoading, setQuoteLoading] = useState(false);
	const [effectLoading, setEffectLoading] = useState(false);
	const allAddOns = useGetCarAddOn();
	const setCarAddOn = useStoreCarAddOn();
	const orderId = useGetOrderId();

	const addOnSelection = useGetCarAddOnSelection();
	const setAddOnSelection = useStoreCarAddOnSelection();
	const storeCarPlan = useStoreCarPlan();

	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);

	const showErrorMessage = (msg) => {
		if (msg) {
			setErrorMessage(msg);
		}
		setIsErrorVisible(true);
	};
	const navigate = useNavigate();

	// console.log(allAddOns);

	const fallbackIconUrl = `${process.env.REACT_APP_API_URL}/assets/img/motor-add-ons/additional-icon.png`;
	const visibleAddOns = (allAddOns || []).filter(
		(addOn) => addOn.imgSrc && addOn.imgSrc !== fallbackIconUrl
	);

	const remainingAddOns =
		(allAddOns || []).filter(
			(addOn) => !addOn.imgSrc || addOn.imgSrc === fallbackIconUrl
		) || [];

	const removeEndorsementHeading = (text) => {
		if (!text) return "";

		// Regex to remove "ENDORSEMENT <code> - " at the beginning of the string
		const cleanedText = text.replace(
			/^ENDORSEMENT\s?[A-Za-z0-9]*\s?-\s?/i,
			""
		);

		return cleanedText.trim(); // Remove any extra spaces at the start or end
	};

	const getDOBFromId = (idNo) => {
		const regex = /^(\d{6})\d{2}\d{3}(\d{1})$/;
		const match = idNo.match(regex);

		if (!match) {
			throw new Error("Invalid ID number format");
		}

		const birthDate = match[1];
		const genderDigit = parseInt(match[2], 10);

		const yearPrefix = birthDate.substring(0, 2);
		const month = birthDate.substring(2, 4);
		const day = birthDate.substring(4, 6);

		const currentYear = new Date().getFullYear();
		const currentCentury = Math.floor(currentYear / 100) * 100;

		let fullYear;

		if (parseInt(yearPrefix, 10) <= currentYear % 100) {
			fullYear = `20${yearPrefix}`;
		} else {
			fullYear = `19${yearPrefix}`;
		}

		const dob = new Date(`${fullYear}-${month}-${day}`);

		const age = currentYear - dob.getFullYear();

		if (isNaN(dob) || age < 0 || age > 120) {
			throw new Error("Invalid birth year in ID number");
		}

		const gender = genderDigit % 2 === 0 ? "F" : "M";

		const formattedDob = dob.toISOString().split("T")[0];

		return {
			dob: formattedDob,
			gender: gender,
			age: age,
		};
	};

	const getAddDrivers = (drivers) => {
		if (selectedPlan.insurer_name === "GENERALI") {
			let id_data;
			if (
				(
					vehicleInfo?.id_type === "nric" || vehicleInfo?.id_type === "NRIC"
				) 
				&& vehicleInfo?.id_no
			) {
				id_data = getDOBFromId(vehicleInfo.id_no);
			}

			// Filter out drivers with blank IC numbers
			const validDrivers = Array.isArray(drivers)
				? drivers.filter((driver) => driver.icnumber && driver.icnumber.trim() !== "")
				: [];

			// If no valid drivers, return policy holder as default
			if (validDrivers.length === 0) {
				return [
					{
						name: vehicleInfo?.owner_name || "THE POLICY HOLDER",
						icnumber: vehicleInfo?.id_no,
						drvdob: id_data?.dob,
						drvgender: id_data?.gender,
						drvrel: "INSD",
					},
				];
			}

			// Otherwise, return only the valid drivers
			return validDrivers;
		}
		return drivers
	}

	const getDrivers = (drivers) => {
		if (selectedPlan.insurer_name === 'ALLIANZ') {
			return allianzadddriver;
		}

		if (selectedPlan.insurer_name !== "TOKIO MARINE") {
			if (!drivers || (Array.isArray(drivers) && drivers.length === 0)) return [{ code: "01", name: vehicleInfo?.owner_name || "THE POLICY HOLDER" }];

			if (drivers[0]?.code === "04") {
				return [{ code: "04", name: "ALL DRIVERS" }];
			} else {
				return [...drivers];
			}
		} else if (selectedPlan.insurer_name === "TOKIO MARINE" || selectedPlan.insurer_name === "TAKAFUL IKHLAS") {
			if (!drivers) return [];

			if (drivers.length > 0) {
				return drivers;
			}
		} 	
	};

	const handleProceedButton = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");

			const getQuote = await getQuoteProceedButton(addOnSelection);

			if (!getQuote?.data) {
				showErrorMessage(getQuote?.response?.data?.message);
				return;
			}

			if (getQuote?.data?.message) {
				showErrorMessage(getQuote?.data?.message);
				return;
			}

			if (getQuote.success) {
				//(getQuote.data);
				storeCarPlan(
					Array.isArray(getQuote.data)
						? getQuote.data[0]
						: getQuote.data
				);
				//(storeCarPlan(getQuote.data));
				setLoading(false);
				navigate(
					policyId
						? `/get-quote/client-info?policy_id=${policyId}`
						: `/get-quote/client-info`
				);
			}
		} catch (error) {
			showErrorMessage("Something went wrong while fetching the quote.");
		} finally {
			setLoading(false);
		}
	};

	const getQuoteFunction = async (updatedSelection) => {
		setQuoteLoading(true);

		try {
			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");

			let extraCoverages;
			
			if (vehicleInfo?.insurer_name === "LIBERTY") {
				extraCoverages = (updatedSelection || [])
					.filter(
						(item) =>
							item.code !== "1" &&
							item.code &&
							item.description &&
							item.sum_insured !== null &&
							item.sum_insured !== undefined &&
							item.code !== "ALD" &&
							item.code !== "AND"
					)
					.map(({ code, description, sum_insured }) => ({
						code: code.replace(/\s+/g, ""),
						description,
						sum_insured: sum_insured
							? sum_insured
							: selectedPlan?.sum_insured,
					}));
			} else {
				extraCoverages = (updatedSelection || [])
					.filter(
						(item) =>
							item.code !== "1" &&
							item.code &&
							item.description &&
							item.sum_insured !== null &&
							item.sum_insured !== undefined &&
							item.code !== "ALD" &&
							item.code !== "AND" && 
							(
								(item.code === "motorCyclePA" || item.code === "windScreen") 
								  ? (item.sum_insured != null && item.sum_insured !== 0)
								  : true
							)
					)
					.map(({ code, description, sum_insured }) => {
						if (code.replace(/\s+/g, "") === "MPA") {
							const selectedPlanCode =
								localStorage.getItem("plan_code");
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								plan_code: selectedPlanCode
									? JSON.parse(selectedPlanCode).code
									: "",
								no_of_seats: selectedVariant?.variant_seat || "",
							};
						}
						if (code.replace(/\s+/g, "") === "PA*P") {
							const selectedPAnPPlan = localStorage.getItem(
								"plan_code"
							);
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								plan_code: selectedPAnPPlan
									? JSON.parse(selectedPAnPPlan).code
									: "",
								plan_sum_insured: selectedPAnPPlan
									? JSON.parse(selectedPAnPPlan).sum_insured
									: "",
							};
						}
						if (code.replace(/\s+/g, "") === "A001") {
							const selectedA001Plan = localStorage.getItem(
								"plan_code_a001"
							);
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								plan_code: selectedA001Plan
									? JSON.parse(selectedA001Plan).code
									: "",
								plan_sum_insured: selectedA001Plan
									? JSON.parse(selectedA001Plan).sum_insured
									: "",
							};
						}
						if (code.replace(/\s+/g, "") === "112") {
							const selectedCART = localStorage.getItem(
								"sompo_cart_selection"
							);
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								cart_amount: selectedCART
									? JSON.parse(selectedCART).amount
									: "",
								cart_days: selectedCART
									? JSON.parse(selectedCART).days
									: "",
							};
						}
						return {
							code: code.replace(/\s+/g, ""),
							description,
							sum_insured,
						};
					});
			}

			let payloads;

			if (policyId) {
				const policyDetails = await viewPolicy(token, { id: policyId });
				const policyData = policyDetails?.data || {};
				const motorInsurance = policyData?.motor_insurance || {};

				let id_data;
				if (
					(motorInsurance.id_type === "nric" ||
						motorInsurance.id_type === "NRIC") &&
					motorInsurance.id_no
				) {
					id_data = getDOBFromId(motorInsurance.id_no);
				}

				const today = new Date(
					policyDetails?.policy_end_date || new Date()
				);
				today.setHours(today.getHours() + 32);

				const inception_date = today.toISOString().split("T")[0];
				const expiry_date = new Date(today);
				expiry_date.setFullYear(expiry_date.getFullYear() + 1);
				expiry_date.setDate(expiry_date.getDate() - 1);

				let today_issue = new Date();

				let issue_date = today_issue.toISOString().split("T")[0];

				payloads = {
					usecode: "",
					id_type: motorInsurance?.id_type,
					id_no: motorInsurance?.id_no,
					veh_reg_no: motorInsurance?.reg_no,
					postcode: motorInsurance?.postcode,
					veh_type: motorInsurance?.veh_type,
					adddriver: [],
					policy_holder_name: motorInsurance?.owner_name,
					ownership_type: motorInsurance?.ownership_type,
					gender_code: id_data?.gender || "",
					marital_code: id_data?.age >= 30 ? "M" : "S",
					dob: id_data?.dob || "",
					address1: "",
					address2: "",
					driveexp: "",
					occupation: "M36",
					cover_note_cate: "NWOO",
					issue_date: issue_date,
					inception_date: inception_date,
					expiry_date: expiry_date.toISOString().split("T")[0],
					class_code:
						motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
					vehicle_class_code:
						motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
					coverage_code: "CO",
					vehicle_use: "Q3",
					make_code: motorInsurance?.make_code || "",
					model_code: motorInsurance?.model_code || "",
					capacity: motorInsurance?.capacity || "",
					uom: "CC",
					make_year: motorInsurance?.make_year || "",
					seats: motorInsurance?.seats || "",
					ncd_from_code: "",
					engine_no: motorInsurance?.engine_no || "",
					chassis_no: motorInsurance?.chassis_no || "",
					nvic_code: motorInsurance?.nvic_code || "",
					sum_insured: motorInsurance?.sum_insured || "",
					email: "",
					hphoneno: "",
					msv_plan_code: "",
					extra_coverages: extraCoverages || [],
					renewal_policy_no: selectedPlan?.renewal_policy_no || "",
					engine_type: selectedPlan?.engine_type,
					drivers: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false,
					isRecon
				};
			} else {
				let id_data;
				if (
					(vehicleInfo.id_type === "nric" ||
						vehicleInfo.id_type === "NRIC") &&
					vehicleInfo.id_no
				) {
					id_data = getDOBFromId(vehicleInfo.id_no);
				}

				let today_issue = new Date();

				let issue_date = today_issue.toISOString().split("T")[0];

				payloads = {
					usecode: "",
					id_type: vehicleInfo.id_type,
					id_no: vehicleInfo.id_no,
					veh_reg_no: vehicleInfo.reg_no,
					postcode: vehicleInfo.postcode,
					veh_type: vehicleInfo.veh_type,
					adddriver: [],
					policy_holder_name: vehicleInfo.ownership_type === "I" ?vehicleInfo.owner_name : vehicleInfo.companyName,
					ownership_type: vehicleInfo.ownership_type,
					gender_code: id_data?.gender,
					marital_code:
						id_data?.age >= 30
							? "M"
							: id_data?.age < 30
							? "S"
							: "O",
					dob: id_data?.dob,
					address1: "",
					address2: "",
					driveexp: "",
					occupation: "M36",
					cover_note_cate: "NWOO",
					issue_date: issue_date,
					inception_date: vehicleInfo.effective_date,
					expiry_date: vehicleInfo.expiry_date,
					class_code:
						vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
					vehicle_class_code:
						vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
					coverage_code: "CO",
					vehicle_use: "Q3",
					make_code: vehicleInfo?.vehicle_details?.make_code || "",
					model_code: vehicleInfo?.vehicle_details?.model_code || "",
					capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
					uom: "CC",
					make_year: vehicleInfo?.vehicle_details?.make_year || "",
					seats: selectedVariant?.variant_seat || "",
					ncd_from_code: "",
					engine_no: vehicleInfo?.vehicle_details?.engine_no || "",
					chassis_no: vehicleInfo?.vehicle_details?.chassis_no || "",
					nvic_code: selectedVariant?.variant_nvic || "",
					sum_insured: selectedPlan?.sum_insured,
					email: "",
					hphoneno: "",
					msv_plan_code: "",
					extra_coverages: extraCoverages || [],
					engine_type: selectedPlan?.engine_type,
					drivers: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
					premium_ref_no: selectedPlan?.premium_ref_no || "",
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false,
					isRecon,
				};
			}

			//console.log("ADD ON: ", payloads.extra_coverages);

			let getQuote;
			if (vehicleInfo?.insurer_name === "RHBI") {
				const rhbPayload = {
					...payloads,
					extra_coverages: [...payloads.extra_coverages.map((coverage)=> {
						if (coverage.code === "E112") {
							return {
								...coverage,
								description: "ENDORSEMENT 112 - COMPENSATION FOR ASSESSED REPAIR TIME (CART)",
								code: "E112",
								cart_days: lonpacCart.unit,
								cart_amount: lonpacCart.amount
							}
						}
						return coverage;
					})],
				}
				getQuote = await getQuotesRhb(token, rhbPayload);
			}
			else if (vehicleInfo?.insurer_name === "GENERALI") {
				getQuote = await getQuotesGen(token, {
					...payloads,
					agree_value: selectedPlan?.agree_value,
					market_value: selectedPlan?.market_value,
					sum_insured: selectedPlan?.sum_insured
				});
			}
			else if (vehicleInfo?.insurer_name === "BERJAYA SOMPO") {
				const sompoPayload = {
					...payloads,
					extra_coverages: [
						...payloads.extra_coverages.map((coverage) => {
							if (coverage.code === "112") {
								return {
									...coverage,
									cart_amount: sompoCart?.amount || "50",
									cart_days: sompoCart?.days || "7",
								};
							}
							return {
								...coverage,
							};
						}),
					],
				};
				getQuote = await getQuotesSompo(token, sompoPayload);
			}
			else if (selectedPlan?.insurer_name === "TOKIO MARINE") {
				const tmimAddOns = JSON.parse(localStorage.getItem("tmim_add_ons")) || [];
			
				const vehicleSI = Number(selectedPlan?.sum_insured || 0);
				const storedE089 = Number(localStorage.getItem("E089_sum_insured") || 0);
			
				// Build payload with ALL add-ons (first quote only)
				const extraCoverages = tmimAddOns.map(a => {
					if (a.code === "E089") {
						let si = storedE089;
						if (!si || si < 500) {
							si = 500;
							localStorage.setItem("E089_sum_insured", 500);
						}
						if (vehicleSI > 0 && si > vehicleSI) si = vehicleSI;
						si = Math.floor(si);
						return { code: "E089", description: a.description, sum_insured: si };
					}
					return { code: a.code, description: a.description, sum_insured: a.sum_insured };
				});
			
				const tmimPayload = {
					...payloads,
					extra_coverages: extraCoverages,
					no_of_driver,
				};
			
				// First quote request
				getQuote = await getQuotesTmim(token, tmimPayload);
			
				// Save TMIM quote add-on master
				const quoteAddOns = getQuote?.data?.[0]?.extra_coverages || [];
				localStorage.setItem("tmimQuoteAddOns", JSON.stringify(quoteAddOns));
			
				// Compute and save correct base gross premium
				const correctBaseGross = Number(selectedPlan.basic_premium) - Number(selectedPlan.ncd_amount || 0);
				localStorage.setItem("tmim_base_gross", correctBaseGross);
			
				// Map selected add-ons to updated amounts
				const storedSelected = JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
			
				const updatedSelected = storedSelected
					.map(sel => quoteAddOns.find(q => q.code === sel.code))
					.filter(Boolean);
			
				setSelectedAddOns(updatedSelected);
				setAddOnPrices(updatedSelected);
			}			
			else if (vehicleInfo?.insurer_name === "LIBERTY") {
				getQuote = await getQuotesLib(token, {
					auth_token: selectedPlan?.auth_token,
					reference_data: selectedPlan?.reference_data,
					quotation_no: selectedPlan?.quotation_no,
					extra_coverages: selectedPlan?.extra_coverages_list,
					road_tax_option: roadTaxOption,
					engine_type: selectedPlan?.engine_type,
					...payloads,
				});
			}
			else if (vehicleInfo?.insurer_name === "TAKAFUL IKHLAS") {
				console.log("TAKAFUL IKHLAS");
				getQuote = await getQuotesIkhlas(token, {
					...payloads,
					sum_insured: selectedPlan?.sum_insured || 0
				});
			}
			else if (vehicleInfo?.insurer_name === "LONPAC") {
				let reqParam2;
				let SDPAInd;

				const hasSDPAR1 = payloads?.extra_coverages?.some(c => c.code === "R1");
				const hasSDPAR2 = payloads?.extra_coverages?.some(c => c.code === "R2");

				if (hasSDPAR1) {
					reqParam2 = "R1";
					SDPAInd = "Y";
				}
				if (hasSDPAR2) {
					reqParam2 = "R2";
					SDPAInd = "Y";
				}

				if (!hasSDPAR1 && !hasSDPAR2) {
					reqParam2 = "";
					SDPAInd = "N";
				}

				const defaultSi = [ "M01", "M11", "M68", "M63", "M65", "M66", "M67" ];
				const defaultVehicleSi = [ "M03", "M17" ];

				const lonpacPayload = {
					...payloads,
					extra_coverages: [...payloads.extra_coverages
						.filter(c => c.code !== "R1" && c.code !== "R2")
						.map((coverage)=> {
							if (defaultSi.includes(coverage.code)) {
								return {
									...coverage,
									si: "0.00",
									unit: "0.00"
								}
							}
							if (defaultVehicleSi.includes(coverage.code)) {
								return {
									...coverage,
									si: selectedPlan?.sum_insured || "0.00",
									unit: "0.00"
								}
							}
							if (coverage.code === "M51") {
								return {
									...coverage,
									description: lonpacCart.name,
									code: "M51",
									si: lonpacCart.si,
									sum_insured: lonpacCart.si,
									unit: lonpacCart.unit
								}
							}
							if (coverage.code === "M02") {
								return {
									...coverage,
									description: lonpacWindscreenSI.name,
									code: "M02",
									si: lonpacWindscreenSI.si,
									unit: "0.00"
								}
							}
							return {
								...coverage
							};
						})
					],
					reqParam2,
					SDPAInd
				}
				getQuote = await getQuotesLonpac(token, lonpacPayload);
			} else if (vehicleInfo?.insurer_name === "TUNE PROTECT") {
				getQuote = await getQuotesTuneProtect(token, {
					...payloads,
					sum_insured: selectedPlan?.sum_insured || 0,
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false,
					quote_id: selectedPlan?.quote_ref_no || selectedPlan?.premium_ref_no || "",
					quoted_amount: selectedPlan?.total_payable || 0
				});
			} else if (selectedPlan?.insurer_name === "TOKIO MARINE") {
				const selectedPlan = JSON.parse(localStorage.getItem("car_plan"));

				let extraCoverages;
				if (selectedPlan?.insurer_name === "TOKIO MARINE") {
					extraCoverages = selectedAddOns;
				} else {
					extraCoverages = JSON.parse(
						localStorage.getItem("car_addOn_selection") ?? "[]"
					);
				}

				let upatedManualAddOns;
				upatedManualAddOns = (extraCoverages || [])
				.map(({ code, description, amount, sum_insured }) => {
					if (code.replace(/\s+/g, "") === "MPA") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
							no_of_seats: selectedVariant?.variant_seat || "",
						};
					}

					if (code.replace(/\s+/g, "") === "PA*P") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured: selectedPlanCode && selectedPlanCode.sum_insured ? selectedPlanCode.sum_insured : 0,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
						};
					}
					if (code.replace(/\s+/g, "") === "A001") {
						const selectedA001Plan = localStorage.getItem(
							"plan_code_a001"
						);
						return {
							code: code.replace(/\s+/g, ""),
							description,
							sum_insured,
							plan_code: selectedA001Plan
								? JSON.parse(selectedA001Plan).code
								: "",
							plan_sum_insured: selectedA001Plan
								? JSON.parse(selectedA001Plan).sum_insured
								: "",
						};
					}
					return {
						code: code.replace(/\s+/g, ""),
						description,
						amount: selectedPlan?.insurer_name === "TOKIO MARINE" ? amount : sum_insured,
					};
				});

				const addonTotal = upatedManualAddOns.reduce((acc, curr) => acc + (parseFloat(curr.amount) || 0), 0);
				console.log(addonTotal);
				const basePremium = parseFloat(selectedPlan?.basic_premium) || 0;
				const ncdAmount = parseFloat(selectedPlan?.ncd_amount) || 0;

				const grossPremium = basePremium - ncdAmount + addonTotal;
				const sst = grossPremium * 0.08;
				const commission = grossPremium * 0.1;
				const stampDuty = 10;
				const totalPayable = grossPremium;

				/*getQuote = {
					success: true,
					data: {
						...selectedPlan,
						sst_premium: ((selectedPlan.basic_premium - selectedPlan.ncd_amount + upatedManualAddOns.reduce((acc, curr) => acc + parseFloat(curr.amount) || 0, 0)) * 0.08),
						gross_premium: (selectedPlan.basic_premium - selectedPlan.ncd_amount + upatedManualAddOns.reduce((acc, curr) => acc + parseFloat(curr.amount) || 0, 0)),
						total_payable: 
						(selectedPlan.basic_premium - selectedPlan.ncd_amount + upatedManualAddOns.reduce((acc, curr) => acc + parseFloat(curr.amount) || 0, 0)) +
						((selectedPlan.basic_premium - selectedPlan.ncd_amount + upatedManualAddOns.reduce((acc, curr) => acc + parseFloat(curr.amount) || 0, 0)) * 0.08) +
						((selectedPlan.basic_premium - selectedPlan.ncd_amount + upatedManualAddOns.reduce((acc, curr) => acc + parseFloat(curr.amount) || 0, 0)) * 0.1) +
						10,
						commission_amount: ((selectedPlan.basic_premium - selectedPlan.ncd_amount + upatedManualAddOns.reduce((acc, curr) => acc + parseFloat(curr.amount) || 0, 0)) * 0.1),
						commission_percent: 10,
						extra_coverages: upatedManualAddOns || [],
						extra_coverages_list: upatedManualAddOns || [],
					},
				};*/

				getQuote = {
					success: true,
					data: {
						...selectedPlan,
						sst_premium: sst,
						gross_premium: grossPremium,
						total_payable: totalPayable,
						commission_amount: commission,
						commission_percent: 10,
						extra_coverages: upatedManualAddOns || [],
						extra_coverages_list: upatedManualAddOns || [],
					},
				};
			} else if (selectedPlan?.insurer_name === "ETIQA") {
				const etiqaPayload = {
					...payloads,
					extra_coverages: [...payloads.extra_coverages.map((coverage)=> {
						console.log(coverage)
						if (coverage.code === "P07A") {
							return {
								...coverage,
								description: etiqaCart.name,
								code: etiqaCart.code,
							}
						}
						if (coverage.code === "P10A") {
							return {
								...coverage,
								description: etiqaLou.name,
								code: etiqaLou.code,
							}
						}
						if (coverage.code === "B089") {
							return {
								...coverage,
								premium: parseFloat(localStorage.getItem("E089_sum_insured") || 0)
							}
						}
						if (coverage.code === "D027") {
							return {
								...coverage,
								sum_insured: parseFloat(JSON.parse(localStorage.getItem(`addon_${"D027"}_selection`)).sum_insured || 0)
							}
						}
						if (coverage.code === "D01A") {
							return {
								...coverage,
								description: etiqaD01A.name,
								code: etiqaD01A.code,
							}
						}
						return {
							...coverage,
						};
					})],
				}
				getQuote = await getQuotesEtiqa(token, etiqaPayload);
			} else if (selectedPlan?.insurer_name === "ALLIANZ") {
				const carAddonSelections = JSON.parse(
					localStorage.getItem("car_addOn_selection") ?? "[]"
				);
				const windscreen = carAddonSelections.find((coverage) => coverage.code === "89");

				let successAddons = [...carAddonSelections]

				if (windscreen && (!windscreen.sum_insured || windscreen.sum_insured < 500)) {
					successAddons = successAddons.filter(item => item.code !== "89")
					showErrorMessage("Please enter a valid sum insured amount for Windscreen. Minimum 500 is required.");
				}

				const sumInsuredCheck = ["89", "101", "102", "97A"]

				const error_message = "Please select/fill in all the required field for the selected add-ons" 
				
				for (const coverage of carAddonSelections) {
					if (sumInsuredCheck.includes(coverage.code)) {
						if (!coverage.sum_insured) {
							successAddons = successAddons.filter(item => item.code !== coverage.code)
							showErrorMessage(error_message);
						}
					}

					if (coverage.code === "PAB-ERW" && !allianzPABERW) {
						successAddons = successAddons.filter(item => item.code !== coverage.code)
						showErrorMessage(error_message);
					}

					if (coverage.code === "PAB3" && !allianzPABERW) {
						successAddons = successAddons.filter(item => item.code !== coverage.code)
						showErrorMessage(error_message);
					}
					
					if (coverage.code === "112" && (!sompoCart || !sompoCart.amount || !sompoCart.days)) {
						successAddons = successAddons.filter(item => item.code !== coverage.code)
						showErrorMessage(error_message);
					}
				}

				setAddOnSelection(successAddons)

				const allianzPayload = {
					...payloads,
					drivers: getDrivers(drivers),
					extra_coverages: [
						...successAddons.map((coverage) => {
							if (coverage.code === "112") {
								return {
									...coverage,
									cart_amount: sompoCart?.amount || "50",
									cart_days: sompoCart?.days || "7",
								};
							}

							if (coverage.code === "PAB-ERW") {
								return {
									...coverage,
									description: allianzPABERW.name,
									plan_code: allianzPABERW.code,
								}
							}

							if (coverage.code === "PAB3") {
								return {
									...coverage,
									description: allianzPAB3.name,
									plan_code: allianzPAB3.code,
								}
							}

							return {
								...coverage
							};
						}),
					],
				};
				getQuote = await getQuotesAllianz(token, allianzPayload);
			} else {
				const selectedPlan = JSON.parse(localStorage.getItem("car_plan"));

				let extraCoverages;
				if (selectedPlan?.insurer_name === "TOKIO MARINE") {
					extraCoverages = selectedAddOns;
				} else {
					extraCoverages = JSON.parse(
						localStorage.getItem("car_addOn_selection") ?? "[]"
					);
				}

				let upatedManualAddOns;
				upatedManualAddOns = (extraCoverages || [])
				.map(({ code, description, amount, sum_insured }) => {
					if (code.replace(/\s+/g, "") === "MPA") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
							no_of_seats: selectedVariant?.variant_seat || "",
						};
					}

					if (code.replace(/\s+/g, "") === "PA*P") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured: selectedPlanCode && selectedPlanCode.sum_insured ? selectedPlanCode.sum_insured : 0,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
						};
					}
					if (code.replace(/\s+/g, "") === "A001") {
						const selectedA001Plan = localStorage.getItem(
							"plan_code_a001"
						);
						return {
							code: code.replace(/\s+/g, ""),
							description,
							sum_insured,
							plan_code: selectedA001Plan
								? JSON.parse(selectedA001Plan).code
								: "",
							plan_sum_insured: selectedA001Plan
								? JSON.parse(selectedA001Plan).sum_insured
								: "",
						};
					}
					return {
						code: code.replace(/\s+/g, ""),
						description,
						amount: selectedPlan?.insurer_name === "TOKIO MARINE" ? amount : sum_insured,
					};
				});

				// VULN-04 residual: Pacific & Orient is priced by P&O through the server, like every other
				// insurer, never by the browser formula below, which left out P&O's loading and its own add-on,
				// tax and stamp-duty figures (see utils/poiQuote.js). No browser fallback on failure.
				if (isPoiPlan(selectedPlan)) {
					return poiPlanFromQuote(await getQuotesPoi(token, payloads), selectedPlan, upatedManualAddOns || []);
				}

				// Great Eastern likewise (utils/greatEasternQuote.js): its issuance refuses any other price.
				if (isGreatEasternPlan(selectedPlan)) {
					return greatEasternPlanFromQuote(await getQuotesGreatEastern(token, payloads), selectedPlan, upatedManualAddOns || []);
				}

				// Takaful Malaysia likewise (utils/takafulMalaysiaQuote.js): STMB re-validates the price at issuance.
				if (isTakafulMalaysiaPlan(selectedPlan)) {
					return takafulMalaysiaPlanFromQuote(await getQuotesTakafulMalaysia(token, payloads), selectedPlan, upatedManualAddOns || []);
				}

				const basePremium = selectedPlan.basic_premium - selectedPlan.ncd_amount;

				const extraCoverageTotal = extraCoverages.reduce(
					(acc, curr) => acc + (parseFloat(curr.sum_insured) || 0),
					0
				);

				const gross_premium = basePremium + extraCoverageTotal;
				const sst_premium = gross_premium * 0.08;
				const commission_amount = gross_premium * 0.1;
				const commission_percent = 10;
				const stamp_duty = 10;
				const total_payable = gross_premium + sst_premium + stamp_duty;

				getQuote = {
					success: true,
					data: {
						...selectedPlan,
						sst_premium,
						gross_premium,
						total_payable,
						commission_amount,
						commission_percent,
						extra_coverages: upatedManualAddOns || [],
						extra_coverages_list: upatedManualAddOns || [],
					},
				};
			}

			return getQuote;
		} catch (error) {
			console.log(error);
			showErrorMessage(error.message || "Failed to get updated quote.");
			return null;
		} finally {
			setQuoteLoading(false);
		}
	};

	const getQuoteProceedButton = async (updatedSelection) => {
		setLoading(true);

		try {
			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");

			let extraCoverages;
			
			if (vehicleInfo?.insurer_name === "LIBERTY") {
				extraCoverages = (updatedSelection || [])
					.filter(
						(item) =>
							item.code !== "1" &&
							item.code &&
							item.description &&
							item.sum_insured !== null &&
							item.sum_insured !== undefined &&
							item.code !== "ALD" &&
							item.code !== "AND"
					)
					.map(({ code, description, sum_insured }) => ({
						code: code.replace(/\s+/g, ""),
						description,
						sum_insured: sum_insured
							? sum_insured
							: selectedPlan?.sum_insured,
					}));
			} else {
				extraCoverages = (updatedSelection || [])
					.filter(
						(item) =>
							item.code !== "1" &&
							item.code &&
							item.description &&
							item.sum_insured !== null &&
							item.sum_insured !== undefined &&
							item.code !== "ALD" &&
							item.code !== "AND" && 
							(
								(item.code === "motorCyclePA" || item.code === "windScreen") 
								  ? (item.sum_insured != null && item.sum_insured !== 0)
								  : true
							)
					)
					.map(({ code, description, sum_insured }) => {
						if (code.replace(/\s+/g, "") === "MPA") {
							const selectedPlanCode =
								localStorage.getItem("plan_code");
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								plan_code: selectedPlanCode
									? JSON.parse(selectedPlanCode).code
									: "",
								no_of_seats: selectedVariant?.variant_seat || "",
							};
						}
						if (code.replace(/\s+/g, "") === "PA*P") {
							const selectedPAnPPlan = localStorage.getItem(
								"plan_code"
							);
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								plan_code: selectedPAnPPlan
									? JSON.parse(selectedPAnPPlan).code
									: "",
								plan_sum_insured: selectedPAnPPlan
									? JSON.parse(selectedPAnPPlan).sum_insured
									: "",
							};
						}
						if (code.replace(/\s+/g, "") === "A001") {
							const selectedA001Plan = localStorage.getItem(
								"plan_code_a001"
							);
							return {
								code: code.replace(/\s+/g, ""),
								description,
								sum_insured,
								plan_code: selectedA001Plan
									? JSON.parse(selectedA001Plan).code
									: "",
								plan_sum_insured: selectedA001Plan
									? JSON.parse(selectedA001Plan).sum_insured
									: "",
							};
						}
						return {
							code: code.replace(/\s+/g, ""),
							description,
							sum_insured,
						};
					});
			}

			let payloads;

			if (policyId) {
				const policyDetails = await viewPolicy(token, { id: policyId });
				const policyData = policyDetails?.data || {};
				const motorInsurance = policyData?.motor_insurance || {};

				let id_data;
				if (
					(motorInsurance.id_type === "nric" ||
						motorInsurance.id_type === "NRIC") &&
					motorInsurance.id_no
				) {
					id_data = getDOBFromId(motorInsurance.id_no);
				}

				const today = new Date(
					policyDetails?.policy_end_date || new Date()
				);
				today.setHours(today.getHours() + 32);

				const inception_date = today.toISOString().split("T")[0];
				const expiry_date = new Date(today);
				expiry_date.setFullYear(expiry_date.getFullYear() + 1);
				expiry_date.setDate(expiry_date.getDate() - 1);

				let today_issue = new Date();

				let issue_date = today_issue.toISOString().split("T")[0];

				payloads = {
					usecode: "",
					id_type: motorInsurance?.id_type,
					id_no: motorInsurance?.id_no,
					veh_reg_no: motorInsurance?.reg_no,
					postcode: motorInsurance?.postcode,
					veh_type: motorInsurance?.veh_type,
					adddriver: adddriver,
					policy_holder_name: motorInsurance?.owner_name,
					ownership_type: motorInsurance?.ownership_type,
					gender_code: id_data?.gender || "",
					marital_code: id_data?.age >= 30 ? "M" : "S",
					dob: id_data?.dob || "",
					address1: "",
					address2: "",
					driveexp: "",
					occupation: "M36",
					cover_note_cate: "NWOO",
					issue_date: issue_date,
					inception_date: inception_date,
					expiry_date: expiry_date.toISOString().split("T")[0],
					class_code:
						motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
					vehicle_class_code:
						motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
					coverage_code: "CO",
					vehicle_use: "Q3",
					make_code: motorInsurance?.make_code || "",
					model_code: motorInsurance?.model_code || "",
					capacity: motorInsurance?.capacity || "",
					uom: "CC",
					make_year: motorInsurance?.make_year || "",
					seats: motorInsurance?.seats || "",
					ncd_from_code: "",
					engine_no: motorInsurance?.engine_no || "",
					chassis_no: motorInsurance?.chassis_no || "",
					nvic_code: motorInsurance?.nvic_code || "",
					sum_insured: motorInsurance?.sum_insured || "",
					email: "",
					hphoneno: "",
					msv_plan_code: "",
					extra_coverages: extraCoverages || [],
					renewal_policy_no: selectedPlan?.renewal_policy_no || "",
					engine_type: selectedPlan?.engine_type,
					drivers: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false,
					isRecon
				};
			} else {
				let id_data;
				if (
					(vehicleInfo.id_type === "nric" ||
						vehicleInfo.id_type === "NRIC") &&
					vehicleInfo.id_no
				) {
					id_data = getDOBFromId(vehicleInfo.id_no);
				}

				let today_issue = new Date();

				let issue_date = today_issue.toISOString().split("T")[0];

				payloads = {
					usecode: "",
					id_type: vehicleInfo.id_type,
					id_no: vehicleInfo.id_no,
					veh_reg_no: vehicleInfo.reg_no,
					postcode: vehicleInfo.postcode,
					veh_type: vehicleInfo.veh_type,
					adddriver: adddriver,
					policy_holder_name: vehicleInfo.ownership_type === "I" ? vehicleInfo.owner_name : vehicleInfo.companyName,
					ownership_type: vehicleInfo.ownership_type,
					gender_code: id_data?.gender,
					marital_code:
						id_data?.age >= 30
							? "M"
							: id_data?.age < 30
							? "S"
							: "O",
					dob: id_data?.dob,
					address1: "",
					address2: "",
					driveexp: "",
					occupation: "M36",
					cover_note_cate: "NWOO",
					issue_date: issue_date,
					inception_date: vehicleInfo.effective_date,
					expiry_date: vehicleInfo.expiry_date,
					class_code:
						vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
					vehicle_class_code:
						vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
					coverage_code: "CO",
					vehicle_use: "Q3",
					make_code: vehicleInfo?.vehicle_details?.make_code || "",
					model_code: vehicleInfo?.vehicle_details?.model_code || "",
					capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
					uom: "CC",
					make_year: vehicleInfo?.vehicle_details?.make_year || "",
					seats: selectedVariant?.variant_seat || "",
					ncd_from_code: "",
					engine_no: vehicleInfo?.vehicle_details?.engine_no || "",
					chassis_no: vehicleInfo?.vehicle_details?.chassis_no || "",
					nvic_code: selectedVariant?.variant_nvic || "",
					sum_insured: selectedPlan?.sum_insured,
					email: "",
					hphoneno: "",
					msv_plan_code: "",
					extra_coverages: extraCoverages || [],
					premium_ref_no: selectedPlan?.premium_ref_no || "",
					engine_type: selectedPlan?.engine_type,
					drivers: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false,
					isRecon
				};
			}

			//console.log("ADD ON: ", payloads.extra_coverages);

			let getQuote;
			if (vehicleInfo?.insurer_name === "RHBI") {
				const rhbPayload = {
					...payloads,
					extra_coverages: [...payloads.extra_coverages.map((coverage)=> {
						if (coverage.code === "E112") {
							return {
								...coverage,
								description: "ENDORSEMENT 112 - COMPENSATION FOR ASSESSED REPAIR TIME (CART)",
								code: "E112",
								cart_days: lonpacCart.unit,
								cart_amount: lonpacCart.amount
							}
						}
						return coverage;
					})],
				}
				getQuote = await getQuotesRhb(token, rhbPayload);
			}
			else if (vehicleInfo?.insurer_name === "GENERALI") {
				getQuote = await getQuotesGen(token, {
					...payloads,
					agree_value: selectedPlan?.agree_value,
					market_value: selectedPlan?.market_value,
					sum_insured: selectedPlan?.sum_insured
				});
			}
			else if (vehicleInfo?.insurer_name === "BERJAYA SOMPO") {
				getQuote = await getQuotesSompo(token, payloads);
			}
			else if (vehicleInfo?.insurer_name === "TOKIO MARINE") {
				const quoteAddOns = JSON.parse(localStorage.getItem("tmimQuoteAddOns")) || [];
				const selectedAddOns = JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
			
				// Build final add-on set for TMIM proceed API
				const finalExtraCoverages = quoteAddOns
					.filter(q => selectedAddOns.some(s => s.code === q.code)) // keep selected only
					.map(q => {
						const selected = selectedAddOns.find(s => s.code === q.code);

						return {
							...q,
							amount: selected.amount,
							sum_insured: selected.sum_insured
						};
					});

				const tmimPayload = {
					...payloads,
					extra_coverages: finalExtraCoverages,
					no_of_driver
				};
			
				console.log("TMIM FINAL PAYLOAD:", tmimPayload);
			
				getQuote = await getQuotesTmim(token, tmimPayload);
			}
			else if (vehicleInfo?.insurer_name === "LIBERTY") {
				getQuote = await getQuotesLib(token, {
					auth_token: selectedPlan?.auth_token,
					reference_data: selectedPlan?.reference_data,
					quotation_no: selectedPlan?.quotation_no,
					extra_coverages: selectedPlan?.extra_coverages_list,
					road_tax_option: roadTaxOption,
					engine_type: selectedPlan?.engine_type,
					...payloads,
				});
			} else if (selectedPlan?.insurer_name === "ETIQA") {
				const etiqaPayload = {
					...payloads,
					extra_coverages: [...payloads.extra_coverages.map((coverage)=> {
						console.log(coverage)
						if (coverage.code === "P07A") {
							return {
								...coverage,
								description: etiqaCart.name,
								code: etiqaCart.code,
							}
						}
						if (coverage.code === "P10A") {
							return {
								...coverage,
								description: etiqaLou.name,
								code: etiqaLou.code,
							}
						}
						if (coverage.code === "B089") {
							return {
								...coverage,
								premium: parseFloat(localStorage.getItem("E089_sum_insured") || 0)
							}
						}
						if (coverage.code === "D027") {
							return {
								...coverage,
								sum_insured: parseFloat(JSON.parse(localStorage.getItem(`addon_${"D027"}_selection`)).sum_insured || 0)
							}
						}
						if (coverage.code === "D01A") {
							return {
								...coverage,
								description: etiqaD01A.name,
								code: etiqaD01A.code,
							}
						}
						return {
							...coverage,
						};
					})],
				}
				getQuote = await getQuotesEtiqa(token, etiqaPayload);
			} else if (vehicleInfo?.insurer_name === "TAKAFUL IKHLAS") {
				console.log("TAKAFUL IKHLAS");
				getQuote = await getQuotesIkhlas(token, {
					...payloads,
					sum_insured: selectedPlan?.sum_insured || 0
				});
			}
			else if (vehicleInfo?.insurer_name === "LONPAC") {
				const selectedPlan = JSON.parse(localStorage.getItem("car_plan"));

				const extraCoverages = selectedPlan.extra_coverages;

				let upatedManualAddOns;
				upatedManualAddOns = (extraCoverages || [])
				.map(({ code, description, amount, sum_insured }) => {
					if (code.replace(/\s+/g, "") === "MPA") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
							no_of_seats: selectedVariant?.variant_seat || "",
						};
					}

					if (code.replace(/\s+/g, "") === "PA*P") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured: selectedPlanCode && selectedPlanCode.sum_insured ? selectedPlanCode.sum_insured : 0,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
						};
					}
					if (code.replace(/\s+/g, "") === "A001") {
						const selectedA001Plan = localStorage.getItem(
							"plan_code_a001"
						);
						return {
							code: code.replace(/\s+/g, ""),
							description,
							sum_insured,
							plan_code: selectedA001Plan
								? JSON.parse(selectedA001Plan).code
								: "",
							plan_sum_insured: selectedA001Plan
								? JSON.parse(selectedA001Plan).sum_insured
								: "",
						};
					}
					return {
						code: code.replace(/\s+/g, ""),
						description,
						amount: amount,
					};
				});

				const basePremium = selectedPlan.basic_premium - selectedPlan.ncd_amount;

				const extraCoverageTotal = extraCoverages.reduce(
					(acc, curr) => acc + (parseFloat(curr.amount) || 0),
					0
				);

				const gross_premium = basePremium + extraCoverageTotal;
				const sst_premium = gross_premium * 0.08;
				const commission_amount = gross_premium * 0.1;
				const commission_percent = 10;
				const stamp_duty = 10;
				const total_payable = gross_premium + sst_premium + stamp_duty;

				getQuote = {
					success: true,
					data: {
						...selectedPlan,
						sst_premium,
						gross_premium,
						total_payable,
						commission_amount,
						commission_percent,
						extra_coverages: upatedManualAddOns || [],
						extra_coverages_list: upatedManualAddOns || [],
					},
				};
			}
			else if (vehicleInfo?.insurer_name === "TUNE PROTECT") {
				getQuote = await getQuotesTuneProtect(token, {
					...payloads,
					sum_insured: selectedPlan?.sum_insured || 0,
					agree_value: selectedPlan?.agree_value || false,
					market_value: selectedPlan?.market_value || false,
					quote_id: selectedPlan?.quote_ref_no || "",
					quoted_amount: selectedPlan?.total_payable || 0
				});
			} else if (selectedPlan?.insurer_name === "ALLIANZ") {
				const carAddonSelections = JSON.parse(
					localStorage.getItem("car_addOn_selection") ?? "[]"
				);
				const windscreen = carAddonSelections.find((coverage) => coverage.code === "89");

				let successAddons = [...carAddonSelections]

				if (windscreen && (!windscreen.sum_insured || windscreen.sum_insured < 500)) {
					successAddons = successAddons.filter(item => item.code !== "89")
					showErrorMessage("Please enter a valid sum insured amount for Windscreen. Minimum 500 is required.");
				}

				const sumInsuredCheck = ["89", "101", "102", "97A"]

				const error_message = "Please select/fill in all the required field for the selected add-ons" 
				
				for (const coverage of carAddonSelections) {
					if (sumInsuredCheck.includes(coverage.code)) {
						if (!coverage.sum_insured) {
							successAddons = successAddons.filter(item => item.code !== coverage.code)
							showErrorMessage(error_message);
						}
					}

					if (coverage.code === "PAB-ERW" && !allianzPABERW) {
						successAddons = successAddons.filter(item => item.code !== coverage.code)
						showErrorMessage(error_message);
					}

					if (coverage.code === "PAB3" && !allianzPABERW) {
						successAddons = successAddons.filter(item => item.code !== coverage.code)
						showErrorMessage(error_message);
					}

					if (coverage.code === "112" && (!sompoCart || !sompoCart.amount || !sompoCart.days)) {
						successAddons = successAddons.filter(item => item.code !== coverage.code)
						showErrorMessage(error_message);
					}
				}

				setAddOnSelection(successAddons)

				const allianzPayload = {
					...payloads,
					drivers: getDrivers(drivers),
					extra_coverages: [
						...successAddons.map((coverage) => {
							if (coverage.code === "112") {
								return {
									...coverage,
									cart_amount: sompoCart?.amount || "50",
									cart_days: sompoCart?.days || "7",
								};
							}

							if (coverage.code === "PAB-ERW") {
								return {
									...coverage,
									description: allianzPABERW.name,
									plan_code: allianzPABERW.code,
								}
							}

							if (coverage.code === "PAB3") {
								return {
									...coverage,
									description: allianzPAB3.name,
									plan_code: allianzPAB3.code,
								}
							}

							return {
								...coverage
							};
						}),
					],
				};
				getQuote = await getQuotesAllianz(token, allianzPayload);
			} else {
				const selectedPlan = JSON.parse(localStorage.getItem("car_plan"));

				let extraCoverages;
				if (selectedPlan?.insurer_name === "TOKIO MARINE") {
					extraCoverages = selectedAddOns;
				} else {
					extraCoverages = JSON.parse(
						localStorage.getItem("car_addOn_selection") ?? "[]"
					);
				}

				let upatedManualAddOns;
				upatedManualAddOns = (extraCoverages || [])
				.map(({ code, description, amount, sum_insured }) => {
					if (code.replace(/\s+/g, "") === "MPA") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
							no_of_seats: selectedVariant?.variant_seat || "",
						};
					}

					if (code.replace(/\s+/g, "") === "PA*P") {
						const selectedPlanCode =
							localStorage.getItem("plan_code");
						return {
							code: code.replace(/\s+/g, ""),
							description,
							amount,
							sum_insured: selectedPlanCode && selectedPlanCode.sum_insured ? selectedPlanCode.sum_insured : 0,
							plan_code: selectedPlanCode
								? JSON.parse(selectedPlanCode).code
								: "",
						};
					}
					if (code.replace(/\s+/g, "") === "A001") {
						const selectedA001Plan = localStorage.getItem(
							"plan_code_a001"
						);
						return {
							code: code.replace(/\s+/g, ""),
							description,
							sum_insured,
							plan_code: selectedA001Plan
								? JSON.parse(selectedA001Plan).code
								: "",
							plan_sum_insured: selectedA001Plan
								? JSON.parse(selectedA001Plan).sum_insured
								: "",
						};
					}
					return {
						code: code.replace(/\s+/g, ""),
						description,
						amount: selectedPlan?.insurer_name === "TOKIO MARINE" ? amount : sum_insured,
					};
				});

				// VULN-04 residual: Pacific & Orient is priced by P&O through the server, like every other
				// insurer, never by the browser formula below, which left out P&O's loading and its own add-on,
				// tax and stamp-duty figures (see utils/poiQuote.js). No browser fallback on failure.
				if (isPoiPlan(selectedPlan)) {
					return poiPlanFromQuote(await getQuotesPoi(token, payloads), selectedPlan, upatedManualAddOns || []);
				}

				// Great Eastern likewise (utils/greatEasternQuote.js): its issuance refuses any other price.
				if (isGreatEasternPlan(selectedPlan)) {
					return greatEasternPlanFromQuote(await getQuotesGreatEastern(token, payloads), selectedPlan, upatedManualAddOns || []);
				}

				// Takaful Malaysia likewise (utils/takafulMalaysiaQuote.js): STMB re-validates the price at issuance.
				if (isTakafulMalaysiaPlan(selectedPlan)) {
					return takafulMalaysiaPlanFromQuote(await getQuotesTakafulMalaysia(token, payloads), selectedPlan, upatedManualAddOns || []);
				}

				const basePremium = selectedPlan.basic_premium - selectedPlan.ncd_amount;

				const extraCoverageTotal = extraCoverages.reduce(
					(acc, curr) => acc + (parseFloat(curr.sum_insured) || 0),
					0
				);

				const gross_premium = basePremium + extraCoverageTotal;
				const sst_premium = gross_premium * 0.08;
				const commission_amount = gross_premium * 0.1;
				const commission_percent = 10;
				const stamp_duty = 10;
				const total_payable = gross_premium + sst_premium + stamp_duty;

				getQuote = {
					success: true,
					data: {
						...selectedPlan,
						sst_premium,
						gross_premium,
						total_payable,
						commission_amount,
						commission_percent,
						extra_coverages: upatedManualAddOns || [],
						extra_coverages_list: upatedManualAddOns || [],
					},
				};
			}

			return getQuote;
		} catch (error) {
			console.log(error);
			showErrorMessage("Failed to get updated quote.");
			return null;
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const fetchAddOns = async () => {
			setEffectLoading(true);
			const queryParameters = new URLSearchParams(window.location.search);
			const tokenParam = queryParameters.get("token");

			// Check if vehicleInfo and selectedPlan exist
			const currentVehicleInfo = vehicleInfo;
			const currentPlan = selectedPlan;
			const payload = {
				insurer_name: currentPlan?.insurer_name || "",
				ownership_name:
					currentVehicleInfo?.ownership_type === "I"
						? "Private"
						: "Business" || "",
				vehicle_type:
					currentVehicleInfo?.veh_type === "car"
						? "Private Car"
						: "Motorcycle" || "",
			};

			let appendLocal = [];
			if (currentPlan.add_ons && orderId) {
				appendLocal = currentPlan.add_ons.map((addon) => {
					const item = {
						insurer_name: addon.insurer_name || "",
						coverage_type: addon.coverage_type || "",
						vehicle_type: addon.vehicle_type || "",
						ownership_type: addon.ownership_type || "",
						add_on_code: addon.add_on_code || "",
						add_on_name: addon.add_on_name || "",
						add_on_description: addon.add_on_description || "",
						sum_insured: addon.add_on_price || 0,
						add_on_icon:
							addon.add_on_icon ||
							defaultIcon,
					};
					return {
						code: item.add_on_code.replace(/\s+/g, ""),
						title: item.add_on_name,
						description:
							item.add_on_description || item.add_on_name,
						imgSrc: item.add_on_icon,
						//insurerName: item.insurer_name,
						//coverageType: item.coverage_type,
						//vehicleType: item.vehicle_type,
						drivers: item.drivers,
						sum_insured: item.sum_insured || 0,
						id: `${addon.id}-${item.insurer_name}-${item.add_on_code}-${item.add_on_name}`,
					};
				});
			}

			if (currentPlan.add_ons && (currentPlan.insurer_name === "ETIQA" || currentPlan.insurer_name === "ALLIANZ")) {
				appendLocal.push(...currentPlan.add_ons);
			}

			try {
				const response = await getMotorAddOns(token, payload);
				if (response?.success && Array.isArray(response?.data)) {
					if (currentPlan?.insurer_name === "TOKIO MARINE") {
						// Store the raw API add-ons for TMIM
						const tmimAddOns = response.data.map(item => ({
							code: item.add_on_code.replace(/\s+/g, "").toUpperCase(),
							description: item.add_on_description,
							sum_insured: Number(item.sum_insured) || 0
						}));
					
						localStorage.setItem("tmim_add_ons", JSON.stringify(tmimAddOns));
					}
					let formattedAddOns = response.data.map((item) => ({
						code: item.add_on_code.replace(/\s+/g, ""),
						title: item.add_on_name,
						description: item.add_on_description,
						imgSrc: item.add_on_icon,
						drivers: item.drivers,
						sum_insured: item.sum_insured || 0,
						id: `${item.insurer_name}-${item.add_on_code}-${item.add_on_name}`,
					}));

					formattedAddOns = formattedAddOns.filter(addon => {
						if (
							addon.code === "E111" &&
							(selectedPlan.ncd_percent === 0 || selectedPlan.ncd_percent === "0.00" || selectedPlan.ncd_percent === 0.0)
						) {
							return false;
						}
						return true;
					});

					console.log("formattedAddOns", formattedAddOns);

					// Filter and sort add-ons
					const addOnsWithIcons =
						(formattedAddOns || []).filter(
							(addOn) =>
								addOn.imgSrc && addOn.imgSrc !== fallbackIconUrl
						) || [];
					const addOnsWithoutIcons =
						(formattedAddOns || []).filter(
							(addOn) =>
								!addOn.imgSrc ||
								addOn.imgSrc === fallbackIconUrl
						) || [];

					// Combine the sorted add-ons with icons first, then without icons
					const sortedAddOns = [
						...addOnsWithIcons,
						...addOnsWithoutIcons,
					];

					setCarAddOn([...formattedAddOns, ...appendLocal]);
					setAddOns(formattedAddOns);
				} else {
					console.error(
						"Failed to fetch add-ons:",
						response?.message || "Unknown error"
					);
				}
			} catch (error) {
				console.error("Error fetching add-ons:", error);
			} finally {
				setEffectLoading(false);
			}
		};

		fetchAddOns();

		if (location.state) {
			const updatedAddOn = location.state;
			const updatedSelection = addOnSelection
				.filter(
					(item) =>
					(
						(item.code === "motorCyclePA" || item.code === "windScreen") 
							? (item.sum_insured != null && item.sum_insured !== 0)
							: true
					)
				)
				.map((item) =>
				item.code === updatedAddOn.code ? updatedAddOn : item
			);
			setAddOnSelection(updatedSelection);
		}
		setEffectLoading(false);
	}, [/*location.state,*/ vehicleInfo, selectedPlan, token]);

	useEffect(() => {
		if (!location.state) return;
	
		const updatedAddOn = location.state;
	
		const updatedSelection = addOnSelection
			.map((item) =>
				item.code === updatedAddOn.code ? updatedAddOn : item
			)
			.filter((item) =>
				(item.code === "motorCyclePA" || item.code === "windScreen")
					? item.sum_insured != null && item.sum_insured !== 0
					: true
			);
	
		console.log("updatedSelection", updatedSelection);
	
		// 1) Immediately update state
		setAddOnSelection(updatedSelection);
	
		// 2) Immediately run Quote API using updatedSelection
		(async () => {
			const getQuote = await getQuoteFunction(updatedSelection);
	
			if (!getQuote?.data || getQuote?.data?.message) {
				showErrorMessage(getQuote?.response?.data?.message || getQuote?.data?.message);
				closeFilterModal();
				return;
			}
	
			if (getQuote.success) {
				if (
					Array.isArray(getQuote.data?.extra_coverages) &&
					getQuote.data.extra_coverages.length > 0
				) {
					setAddOnPrices(getQuote.data.extra_coverages);
				}
	
				// NOT TOKIO MARINE
				if (selectedPlan.insurer_name !== "TOKIO MARINE") {
					storeCarPlan(
						Array.isArray(getQuote.data)
							? getQuote.data[0]
							: getQuote.data
					);
				} else {
					// TMIM special handling
					const tmimBaseGross = parseFloat(localStorage.getItem("tmim_base_gross")) || 0;
					const tmimQuoteAddOns = JSON.parse(localStorage.getItem("tmimQuoteAddOns") || "[]");
					const mergedAddOns = tmimQuoteAddOns
						.map(addon => {
							const updated = updatedSelection.find(u => u.code === addon.code);
							return updated
								? { ...addon, ...updated, sum_insured: updated.sum_insured }
								: addon;
						})
						.filter(addon => {
							// Only keep add-ons user selected or mandatory ones
							const selected = updatedSelection.find(u => u.code === addon.code);

							// If user has no entry in updatedSelection → REMOVE IT
							return !!selected;
						});

					const addonTotal = mergedAddOns.reduce((sum, a) => {
						return sum + (parseFloat(a.amount) || 0);
					}, 0);

					console.log("mergedAddOns: ", mergedAddOns);
	
					const gross = tmimBaseGross + addonTotal;
					const sst = gross * 0.08;
					const commission = gross * 0.1;
	
					storeCarPlan({
						...selectedPlan,
						extra_coverages: mergedAddOns,
						gross_premium: gross,
						sst_premium: sst,
						commission_amount: commission,
						total_payable: gross
					});
				}
			}
		})();
	}, [location.state]);	

	useEffect(() => {
		const tmimQuoteAddOns =
			JSON.parse(localStorage.getItem("tmimQuoteAddOns")) || null;
		const E089_sum_insured = localStorage.getItem("E089_sum_insured") || "";

		const runEffect = async () => {
			setLoading(true);
			const queryParameters = new URLSearchParams(window.location.search);
			const policyId = queryParameters.get("policy_id");

			let payloads;
			let getQuote;
			let extraCoverages;
			if (selectedPlan.insurer_name === "TOKIO MARINE") {
				extraCoverages = (allAddOns || [])
					.filter(
						(item) => {
							const cleanCode = item.code?.replace(/\s+/g, "").toUpperCase();
					
							// Skip if required fields are missing
							if (
								!cleanCode ||
								!item.description ||
								item.sum_insured === null ||
								item.sum_insured === undefined
							) {
								return false;
							}
					
							// Exclude specific codes
							if (["1", "ALD", "AND"].includes(cleanCode)) return false;
					
							// Exclude E111 if NCD is 0
							if (
								cleanCode === "E111" &&
								(selectedPlan.ncd_percent === 0 || selectedPlan.ncd_percent === "0.00" || selectedPlan.ncd_percent === 0.0)
							) {
								return false;
							}
					
							return true;
						}
					)
					.map(({ code, description, sum_insured }) => {
						const cleanCode = code.replace(/\s+/g, "").toUpperCase();

						if (cleanCode === "MPA") {
							const selectedPlanCode = localStorage.getItem("plan_code");
							return {
								code: cleanCode,
								description,
								sum_insured,
								plan_code: selectedPlanCode
									? JSON.parse(selectedPlanCode).code
									: "",
								no_of_seats: selectedVariant?.variant_seat || "",
							};
						}

						if (cleanCode === "PA*P") {
							const selectedPlanCode = localStorage.getItem("plan_code");
							return {
								code: cleanCode,
								description,
								sum_insured: selectedPlanCode && selectedPlanCode.sum_insured ? selectedPlanCode.sum_insured : 0,
								plan_code: selectedPlanCode
									? JSON.parse(selectedPlanCode).code
									: "",
							};
						}

						if (cleanCode === "A001") {
							const selectedA001Plan = localStorage.getItem(
								"plan_code_a001"
							);
							return {
								code: cleanCode,
								description,
								sum_insured,
								plan_code: selectedA001Plan
									? JSON.parse(selectedA001Plan).code
									: "",
								plan_sum_insured: selectedA001Plan
									? JSON.parse(selectedA001Plan).sum_insured
									: "",
							};
						}

						if (cleanCode === "E089") {
							return {
								code: cleanCode,
								description,
								sum_insured: E089_sum_insured
									? parseFloat(E089_sum_insured)
									: 200,
							};
						}

						return {
							code: cleanCode,
							description,
							sum_insured,
						};
					});

				if (policyId) {
					const policyDetails = await viewPolicy(token, { id: policyId });
					const policyData = policyDetails?.data || {};
					const motorInsurance = policyData?.motor_insurance || {};

					let id_data;
					if (
						(motorInsurance.id_type === "nric" ||
							motorInsurance.id_type === "NRIC") &&
						motorInsurance.id_no
					) {
						id_data = getDOBFromId(motorInsurance.id_no);
					}

					const today = new Date(policyDetails?.policy_end_date || new Date());
					today.setHours(today.getHours() + 32);

					const inception_date = today.toISOString().split("T")[0];
					const expiry_date = new Date(today);
					expiry_date.setFullYear(expiry_date.getFullYear() + 1);
					expiry_date.setDate(expiry_date.getDate() - 1);

					let today_issue = new Date();

					let issue_date = today_issue.toISOString().split("T")[0];

					payloads = {
						usecode: "",
						id_type: motorInsurance?.id_type,
						id_no: motorInsurance?.id_no,
						veh_reg_no: motorInsurance?.reg_no,
						postcode: motorInsurance?.postcode,
						veh_type: motorInsurance?.veh_type,
						adddriver: adddriver,
						policy_holder_name: motorInsurance?.owner_name,
						ownership_type: motorInsurance?.ownership_type,
						gender_code: id_data?.gender || "",
						marital_code: id_data?.age >= 30 ? "M" : "S",
						dob: id_data?.dob || "",
						address1: "",
						address2: "",
						driveexp: "",
						occupation: "M36",
						cover_note_cate: "NWOO",
						issue_date: issue_date,
						inception_date: inception_date,
						expiry_date: expiry_date.toISOString().split("T")[0],
						class_code: motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
						vehicle_class_code:
							motorInsurance?.veh_type === "motorcycle" ? "01" : "02",
						coverage_code: "CO",
						vehicle_use: "Q3",
						make_code: motorInsurance?.make_code || "",
						model_code: motorInsurance?.model_code || "",
						capacity: motorInsurance?.capacity || "",
						uom: "CC",
						make_year: motorInsurance?.make_year || "",
						seats: motorInsurance?.seats || "",
						ncd_from_code: "",
						engine_no: motorInsurance?.engine_no || "",
						chassis_no: motorInsurance?.chassis_no || "",
						nvic_code: motorInsurance?.nvic_code || "",
						sum_insured: motorInsurance?.sum_insured || "",
						email: "",
						hphoneno: "",
						msv_plan_code: "",
						extra_coverages: extraCoverages || [],
						renewal_policy_no: selectedPlan?.renewal_policy_no || "",
						engine_type: selectedPlan?.engine_type,
						drivers: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
						isRecon,
						isRecon,
					};
				} else {
					let id_data;
					if (
						(vehicleInfo.id_type === "nric" ||
							vehicleInfo.id_type === "NRIC") &&
						vehicleInfo.id_no
					) {
						id_data = getDOBFromId(vehicleInfo.id_no);
					}

					let today_issue = new Date();

					let issue_date = today_issue.toISOString().split("T")[0];

					payloads = {
						usecode: "",
						id_type: vehicleInfo.id_type,
						id_no: vehicleInfo.id_no,
						veh_reg_no: vehicleInfo.reg_no,
						postcode: vehicleInfo.postcode,
						veh_type: vehicleInfo.veh_type,
						adddriver: adddriver,
						policy_holder_name: vehicleInfo.ownership_type === "I" ? vehicleInfo.owner_name : vehicleInfo.companyName,
						ownership_type: vehicleInfo.ownership_type,
						gender_code: id_data?.gender,
						marital_code:
							id_data?.age >= 30 ? "M" : id_data?.age < 30 ? "S" : "O",
						dob: id_data?.dob,
						address1: "",
						address2: "",
						driveexp: "",
						occupation: "M36",
						cover_note_cate: "NWOO",
						issue_date: issue_date,
						inception_date: vehicleInfo.effective_date,
						expiry_date: vehicleInfo.expiry_date,
						class_code: vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
						vehicle_class_code:
							vehicleInfo?.veh_type === "motorcycle" ? "01" : "02",
						coverage_code: "CO",
						vehicle_use: "Q3",
						make_code: vehicleInfo?.vehicle_details?.make_code || "",
						model_code: vehicleInfo?.vehicle_details?.model_code || "",
						capacity: vehicleInfo?.vehicle_details?.veh_capacity || "",
						uom: "CC",
						make_year: vehicleInfo?.vehicle_details?.make_year || "",
						seats: selectedVariant?.variant_seat || "",
						ncd_from_code: "",
						engine_no: vehicleInfo?.vehicle_details?.engine_no || "",
						chassis_no: vehicleInfo?.vehicle_details?.chassis_no || "",
						nvic_code: selectedVariant?.variant_nvic || "",
						sum_insured:
							selectedVariant.variant_ism_market_value &&
							selectedVariant.variant_ism_market_value !== "" &&
							selectedVariant.variant_ism_market_value !== "0.00"
								? selectedVariant?.variant_ism_market_value
								: selectedPlan?.sum_insured,
						email: "",
						hphoneno: "",
						msv_plan_code: "",
						extra_coverages: extraCoverages || [],
						engine_type: selectedPlan?.engine_type,
						drivers: selectedPlan?.insurer_name === "GENERALI" ? getAddDrivers(adddriver) : getDrivers(drivers),
						isRecon
					};
				}
				if (selectedPlan.insurer_name === "TOKIO MARINE" && location.state) {
					setEffectLoading(false);
					return;
				}
				
				if (vehicleInfo?.insurer_name === "TOKIO MARINE" && location.state) {
					setEffectLoading(false);
					return;
				}
				if (vehicleInfo?.insurer_name === "TOKIO MARINE") {
					try {
						getQuote = await getQuotesTmim(token, {
							...payloads,
							no_of_driver,
							sum_insured: selectedPlan?.sum_insured || 0,
						});
				
						const quoteAddOns = getQuote?.data[0]?.extra_coverages || [];
				
						// Save master TMIM add-ons (used by handleToggleAddon)
						localStorage.setItem("tmimQuoteAddOns", JSON.stringify(quoteAddOns));
						setTmimQuoteAddOns(quoteAddOns);
				
						// Sync only already-selected add-ons with fresh amounts
						const storedAddOns = JSON.parse(localStorage.getItem("car_addOn_selection") || "[]");
				
						const updatedSelectedAddOns = storedAddOns
							.map(stored => {
								const quoteAddon = quoteAddOns.find(q => q.code === stored.code);
								if (!quoteAddon) return null;
								return {
									...stored,
									amount: quoteAddon.amount || "0.00",
									sum_insured: quoteAddon.sum_insured || stored.sum_insured,
								};
							})
							.filter(a => a && Number(a.amount) > 0);
				
						setSelectedAddOns(updatedSelectedAddOns);
						setAddOnPrices(updatedSelectedAddOns);
						updatePlanPrice(updatedSelectedAddOns);
				
						setEffectLoading(false);
					} catch (error) {
						setLoading(false);
					}
				}
			}
			setLoading(false)
		};

		runEffect();
	}, []);

	useEffect(() => {
		const car_addOn_selection = JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
		const storedE089 = JSON.parse(localStorage.getItem("selectedE089Addon"));
		const tmimQuoteAddOns = JSON.parse(localStorage.getItem("tmimQuoteAddOns")) || [];
	
		const selectedWithAmount = car_addOn_selection
			.filter(
				(item) =>
					(
						(item.code === "motorCyclePA" || item.code === "windScreen") 
						? (item.sum_insured != null && item.sum_insured !== 0)
						: true
					)
			)
			.map(sel => tmimQuoteAddOns.find(q => q.code === sel.code))
			.filter(Boolean); // remove nulls in case not found
	
		// Add E089 if it was stored and not already in the list
		if (storedE089 && !selectedWithAmount.some(a => a.code === "E089")) {
			const fullE089 = tmimQuoteAddOns.find(a => a.code === "E089");
			if (fullE089) selectedWithAmount.push(fullE089);
		}
	
		setSelectedAddOns(selectedWithAmount);
	}, []);

	const handleToggleAddon = (addon) => {
		console.log('addon', addon)
		const isAlreadySelected = selectedAddOns.some((a) => a.code === addon.code);
		const selected = JSON.parse(localStorage.getItem("car_addOn_selection") || "[]");
		console.log("selected addons", selectedAddOns)

		// Handle E089 separately
		if (addon.code === "E089") {
			const quoteAddOns = JSON.parse(localStorage.getItem("tmimQuoteAddOns")) || [];
			const storedAddOns = JSON.parse(localStorage.getItem("car_addOn_selection") || "[]");

			const isAlreadySelected = selectedAddOns.some(a => a.code === "E089");

			if (isAlreadySelected) {
				// 1. Remove from UI selection
				const updated = selectedAddOns.filter(a => a.code !== "E089");
				setSelectedAddOns(updated);

				// 2. Remove from stored selections
				const newStored = storedAddOns.filter(a => a.code !== "E089");
				localStorage.setItem("car_addOn_selection", JSON.stringify(newStored));

				// 3. Remove stored SI
				localStorage.removeItem("E089_sum_insured");
				localStorage.removeItem("selectedE089Addon");

				// 4. Update pricing immediately
				updatePlanPrice(updated);

				return;
			}
		
			// Selecting E089 → ensure sum insured exists
			let storedAmount = localStorage.getItem("E089_sum_insured");
		
			if (!storedAmount || Number(storedAmount) < 500) {
				// Force user to input sum insured (go to SI page)
				navigate("/get-quote/add-on-sum-insured", {
					state: { addOn: addon }
				});
				return;
			}
		
			// Now add E089 using quote values + stored sum insured
			const quote = quoteAddOns.find(q => q.code === "E089") || {};
		
			const addonToAdd = {
				...quote,
				sum_insured: Number(storedAmount),
				amount: Number(storedAmount) * 0.15 // <-- If TMIM formula is known, update here
			};
		
			const updatedSelected = [...selectedAddOns, addonToAdd];
			setSelectedAddOns(updatedSelected);
		
			const newStored = [...storedAddOns.filter(a => a.code !== "E089"), addonToAdd];
			localStorage.setItem("car_addOn_selection", JSON.stringify(newStored));
		
			return;
		}

		if (addon.code === "M02") {
			if (!selected.some((a) => a.code === addon.code)) {
				// Deselecting E089
				const updated = selectedAddOns.filter((a) => a.code !== "M02");
				setSelectedAddOns(updated);
				localStorage.removeItem("selectedM02Addon");
	
				// Update add-on prices and plan price
				const storedAddOns = JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
				const updatedSelectedAddOns = storedAddOns
					.map(stored => {
						const quoteAddon = updated.find(q => q.code === stored.code);
						if (!quoteAddon) return null;
						return {
							...stored,
							amount: quoteAddon.amount || "0.00",
							sum_insured: quoteAddon.sum_insured || stored.sum_insured,
						};
					})
					.filter(addon => addon && addon.amount && Number(addon.amount) > 0);
	
				setAddOnPrices(updatedSelectedAddOns);
				updatePlanPrice(updated);
			} else {
				// Selecting E089 – navigate to sum insured page
				localStorage.setItem("selectedE089Addon", JSON.stringify(addon));
				navigate("/get-quote/add-on-m02", {state: { addOn: addon }});
			}
			return;
		}
	
		const getTmimQuoteAddOns = JSON.parse(localStorage.getItem("tmimQuoteAddOns")) || [];
		const isSelected = selectedAddOns.some(item => item.code === addon.code);
	
		let updatedAddOns;
		if (isSelected) {
			// Remove from selection
			updatedAddOns = selectedAddOns.filter(item => item.code !== addon.code);
		} else {
			// Get the full object with amount from getTmimQuoteAddOns
			const fullAddOn = getTmimQuoteAddOns.find(item => item.code === addon.code);
			if (fullAddOn) {
				updatedAddOns = [...selectedAddOns, fullAddOn];
			} else {
				console.warn(`Add-on ${addon.code} not found in quote response`);
				updatedAddOns = [...selectedAddOns];
			}
		}

		const storedAddOns = JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
		const quoteAddOns = updatedAddOns || [];
		const updatedSelectedAddOns = storedAddOns
			.map(stored => {
				const quoteAddon = quoteAddOns.find(q => q.code === stored.code);
				
				if (!quoteAddon) return null; // skip if no matching quote add-on				
				return {
					...stored,             // get description & other fields from stored
					amount: quoteAddon.amount || "0.00",  // overwrite amount from quote
					sum_insured: quoteAddon.sum_insured || stored.sum_insured,
					// add or overwrite other needed fields from quoteAddon if any
					};
				})
				.filter(addon => addon && addon.amount && Number(addon.amount) > 0);
	
		setAddOnPrices(updatedSelectedAddOns);
		setSelectedAddOns(updatedAddOns);
		updatePlanPrice(updatedAddOns);
	};

	const updatePlanPrice = (updatedAddOns) => {
		const basePremium = parseFloat(selectedPlan?.basic_premium) || 0;
		const ncdAmount = parseFloat(selectedPlan?.ncd_amount) || 0;
		const allRiderAmount = parseFloat(selectedPlan?.all_rider_amount) || 0;
	  
		const addonTotal = updatedAddOns.reduce((sum, item) => {
			const value = parseFloat(item.amount) || 0;
			return sum + value;
		}, 0);
	  
		const grossPremium = basePremium + allRiderAmount - ncdAmount + addonTotal;
		const sst = grossPremium * 0.08;
		const commission = grossPremium * 0.1;
		const stampDuty = 10;
	  
		const totalPayable = grossPremium;
	  
		storeCarPlan({
			...selectedPlan,
			extra_coverages: updatedAddOns,
			gross_premium: grossPremium,
			sst_premium: sst,
			commission_amount: commission,
			commission_percent: 10,
			total_payable: totalPayable,
		});
	};	  

	const closeFilterModal = () => {
		setIsModalVisible(false);
	};

	const handleOtherClick = () => {
		navigate(`/get-quote/add-on-others`, { state: { remainingAddOns } });
	};

	const getAddOnDescription = (code) => {
		// Get the stored add-ons from localStorage
		let storedAddOns;
		let selectedAddOn;
		if (selectedPlan?.insurer_name == "TOKIO MARINE") {
			storedAddOns = JSON.parse(localStorage.getItem("tmim_add_ons")) || [];

			const matched = storedAddOns.find(addOn => addOn.code === code);
			return matched?.description || matched?.code;
		} else {
			selectedAddOn = JSON.parse(localStorage.getItem("car_addOn_selection")) || [];
			storedAddOns = selectedAddOn.map((addon) => ({
				add_on_code: addon.code || "",
				add_on_name: addon.title || "",
				add_on_description: addon.description || ""
			}));
		}
	  
		// Find the add-on with the matching code
		const matched = storedAddOns.find(addOn => addOn.add_on_code === code);
	  
		// Return the description if found, otherwise return the code
		return matched?.add_on_name || matched?.add_on_description;
	};
	const apiInsurers = [
		"GENERALI",
		"RHBI",
		"BERJAYA SOMPO",
		"TOKIO MARINE",
		"LIBERTY"
	];

	return (
		<div className="addon-content-wrapper">
			<div className="get-quote-container d-m-column">
				<div className="get-quote-form-section w-100">
					<div className="d-flex flex-row justify-content-between w-100">
						<h3>Add-Ons</h3>
						<div className="grid">
							{/* Render Add-ons with icons */}
							{visibleAddOns.map((addOn) => (
								<div
									key={addOn.id}
									className="col-lg-3 add-on-card"
								>
									<img
										style={{
											width: "auto",
											height: "80px",
										}}
										src={addOn.imgSrc}
										alt={removeEndorsementHeading(
											addOn.title
										)}
									/>
									<p>
										{removeEndorsementHeading(addOn.title)}
									</p>
									<Button
										disabled={loading}
										label={
											addOnSelection.find(
												(item) => item.id === addOn.id
											) ? (
												<>
													<i
														className="pi pi-check"
														style={{
															marginRight: "8px",
															verticalAlign:
																"middle",
															fontWeight: "bold",
														}}
													></i>
													<span
														style={{
															fontWeight: "bold",
														}}
													>
														Selected
													</span>
												</>
											) : (
												<>
													<i
														className="pi pi-plus"
														style={{
															marginRight: "8px",
															verticalAlign:
																"middle",
															marginTop: "-4px",
															fontWeight: "bold",
														}}
													></i>
													<span
														style={{
															fontWeight: "bold",
														}}
													>
														Select
													</span>
												</>
											)
										}
										className={`select-btn ${
											addOnSelection.find(
												(item) => item.id === addOn.id
											)
												? "selected"
												: ""
										}`}
										onClick={async () => {
											const cleanedSelection = (
												addOnSelection || []
											).filter(
												(item) =>
													typeof item === "object" &&
													item !== null &&
													item.id
											);

											let updatedSelection;

											if (
												cleanedSelection.find(
													(item) =>
														item.id === addOn.id
												)
											) {
												updatedSelection =
													cleanedSelection.filter(
														(item) =>
															item.id !== addOn.id
													);
											} else {
												updatedSelection = [
													...cleanedSelection,
													addOn,
												];
											}

											setAddOnSelection(updatedSelection);

											const sumInsuredCodes = [
												"E89",
												"WSCR",
												"89",
												"89A",
												"E089",
												"W/S",
												"windScreen",
												"rideEasy",
												"motorCyclePA",
												"B089"
											];
											const isAlreadySelected =
												cleanedSelection.find((item) =>
													sumInsuredCodes.includes(
														item.code
													)
												);

											if (
												!isAlreadySelected &&
												sumInsuredCodes.includes(
													addOn.code
												)
											) {
												if (selectedPlan?.insurer_name === "TOKIO MARINE") {
													handleToggleAddon(addOn); // handle Tokio Marine quote pricing
												}

												const queryParameters =
													new URLSearchParams(
														window.location.search
													);
												const policyId =
													queryParameters.get(
														"policy_id"
													);

												navigate(
													policyId
														? `/get-quote/add-on-sum-insured?policy_id=${policyId}`
														: `/get-quote/add-on-sum-insured`,
													{ state: { addOn } }
												);
											} else if (!cleanedSelection.find(item => item.code === "M02") && addOn.code === "M02") {
												const queryParameters =
													new URLSearchParams(
														window.location.search
													);
												const policyId =
													queryParameters.get(
														"policy_id"
													);

												navigate(
													policyId
														? `/get-quote/add-on-m02?policy_id=${policyId}`
														: `/get-quote/add-on-m02`,
													{ state: { addOn } }
												);
											} else if (selectedPlan?.insurer_name === "TOKIO MARINE") {
												handleToggleAddon(addOn);
											} else {
												//console.log(updatedSelection);
												const getQuote =
													await getQuoteFunction(
														updatedSelection
													);

												if (!getQuote?.data) {
													showErrorMessage(
														getQuote?.response?.data
															?.message
													);
													return;
												}

												if (getQuote?.data?.message) {
													showErrorMessage(
														getQuote?.data?.message
													);
													return;
												}

												if (getQuote.success) {
													setAddOnPrices(
														getQuote.data
															.extra_coverages
													);

													storeCarPlan(
														Array.isArray(
															getQuote.data
														)
															? getQuote.data[0]
															: getQuote.data
													);
												}
											}
										}}
									/>
								</div>
							))}
							{/* "Other" Button */}
							{remainingAddOns.length > 0 && (
								<div
									className="col-lg-3 add-on-card other-card"
									onClick={handleOtherClick}
								>
									<div className="other-container">
										<button className="circle-button">
											+
										</button>
										<p className="other-text">Other</p>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="btn-footer px-4 pb-4">
						{selectedPlan && (
							<div className="w-100">
								{/* <div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
									<div className="d-flex flex-row flex-wrap align-items-start col-sm-6 w-50">
										<span className="text-left formatted-text">{`| Plan for`}</span>
										<p className="my-0 fw-bold">{`TTT`}</p>
									</div>
									<div className="col-sm-6 w-50">
										<Image
											src={selectedPlan.image_url}
											alt={selectedPlan.insurer_name}
										/>
									</div>
								</div> */}

								<hr />

								<div className="d-flex flex-row flex-wrap justify-content-between align-items-center py-2">
									{/* <div className="w-50">
										{selectedPlan?.discount_percent > 0.0 ? (
											<>
												<span className="fs-xl fw-bold">
													{`RM ${
														new Intl.NumberFormat("en-US", {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(selectedPlan?.basic_premium) || ""
													}`}
												</span>
												<span>{" / after discount"}</span>
												<p className="original-price color-primary">
													<s>{`RM ${
														new Intl.NumberFormat("en-US", {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(selectedPlan?.basic_premium) || ""
													}`}</s>
												</p>
											</>
										) : (
											<>
												<span className="fs-xl fw-bold">
													{`RM ${
														new Intl.NumberFormat("en-US", {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(selectedPlan?.basic_premium) || ""
													}`}
												</span>
											</>
										)}
									</div> */}

									{/* <div className="w-50">
										<span
											className="text-right fw-bold color-primary"
											onClick={() => setIsModalVisible(true)}
										>{`View Details`}</span>
									</div> */}

									<Dialog
										className="filter-modal d-flex flex-row bg-white p-40 gap-2"
										modal
										header={`Filters`}
										visible={isModalVisible}
										style={{
											borderRadius: "24px 24px 0 0",
											margin: 0,
											width: "100vw",
											overflowY: "auto",
										}}
										position={"bottom"}
										onHide={closeFilterModal}
										content={({ hide }) => (
											<>
												<div className="filters w-100">
													<div className="mb-4">
														{selectedPlan && (
															<div className="w-100">
																<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
																	<div className="d-flex flex-row flex-wrap align-items-start text-left col-sm-6 w-50">
																		<span className="text-left formatted-text">{`Selected Plan for`}</span>
																		<p className="my-0 fw-bold">{getInsurerName(selectedPlan.insurer_name)}</p>
																	</div>
																	<div className="col-sm-6 w-50">
																		<Image
																			width="100%"
																			height="auto"
																			src={
																				selectedPlan.image_url
																			}
																			alt={
																				selectedPlan.insurer_name
																			}
																			style={{
																				maxWidth:
																					[
																						"GENERALI",
																						"BERJAYA SOMPO",
																						"TOKIO MARINE",
																						"TUNE PROTECT",
																						"TAKAFUL IKHLAS",
																					].includes(
																						selectedPlan.insurer_name
																					)
																						? "100px"
																						: "150px",
																				height: "auto",
																				display:
																					"block",
																				margin: "0 auto",
																			}}
																		/>
																	</div>
																</div>

																<hr />

																<div className="d-flex flex-row flex-wrap justify-content-between align-items-center py-2">
																	<div className="w-50">
																		<span className="fs-xl fw-bold">
																			{`RM ${
																				new Intl.NumberFormat("en-US", {
																					minimumFractionDigits: 2,
																					maximumFractionDigits: 2,
																				}).format(
																					selectedPlan?.gross_premium || 0
																					)
																				}`
																			}
																		</span>
																	</div>

																	<div className="w-50 text-right">
																		<span
																			className="text-right fw-bold color-primary"
																			style={{
																				marginLeft:
																					"auto", // Ensures it aligns to the right in a flex container
																				cursor: "pointer", // Ensures it's clickable
																			}}
																			onClick={() =>
																				setIsModalVisible(
																					false
																				)
																			}
																		>
																			Hide
																			Details
																		</span>
																	</div>
																</div>

																<div className="col-lg-6 text-left">
																	<h4>
																		Policy
																		Details
																	</h4>
																	<hr />
																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">
																				{
																					"Vehicle"
																				}
																			</span>
																		</div>
																		<div className="vw-50 text-right">
																			<span className="fw-medium color-heading">
																				{vehicleInfo?.vehicle}
																			</span>
																		</div>
																	</div>

																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">
																				{
																					"Registration Car No."
																				}
																			</span>
																		</div>
																		<div className="vw-50 text-right">
																			<span className="fw-medium color-heading">
																				{
																					vehicleInfo?.reg_no
																				}
																			</span>
																		</div>
																	</div>

																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">
																				{
																					"Year of Manufacture"
																				}
																			</span>
																		</div>
																		<div className="vw-50 text-right">
																			<span className="fw-medium color-heading">
																				{
																					vehicleInfo?.make_year
																				}
																			</span>
																		</div>
																	</div>

																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">
																				{
																					"Sum Insured"
																				}
																			</span>
																		</div>
																		<div className="vw-50 text-right">
																			{selectedPlan?.sum_insured && (
																				<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
																					"en-US",
																					{
																						minimumFractionDigits: 2,
																						maximumFractionDigits: 2,
																					}
																				).format(
																					selectedPlan?.sum_insured ||
																						0
																				)}`}</span>
																			)}
																		</div>
																	</div>

																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">
																				{t(`healthInsurance.healthPayment.protectionType`)}
																			</span>
																		</div>
																		<div className="vw-50 text-right">
																			<span className="fw-medium color-heading">
																				{t(`autoInsurance.addOns.comprehensive`)}
																			</span>
																		</div>
																	</div>
																</div>

																<div className="col-lg-6 text-left">
																	<h4>
																		Premium
																		Details
																	</h4>
																	<hr />
																	{selectedPlan?.insurer_name === "TUNE PROTECT" &&
																		<div className="d-flex justify-content-between align-items-center pb-2">
																			<div className="vw-50 text-left">
																				<span className="formatted-text">
																					{vehicleInfo?.veh_type === "car" ? 'Tune Motor Easy' : 'Tune Bike Easy'}
																				</span>
																			</div>
																		</div>
																	}

																	{selectedPlan?.insurer_name !== "ETIQA" && (
																		<div className="d-flex justify-content-between align-items-center pb-2">
																			<div className="vw-50 text-left">
																				<span className="formatted-text">
																					{t(`autoInsurance.addOns.sumInsured`)}
																				</span>
																			</div>
																			<div className="vw-50 text-right">
																				<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
																					"en-US",
																					{
																						minimumFractionDigits: 2,
																						maximumFractionDigits: 2,
																					}
																				).format(
																					selectedPlan?.sum_insured ||
																						0
																				)}`}</span>
																			</div>
																		</div>
																	)}

																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">
																				{t(`autoInsurance.addOns.basicPremium`)}
																			</span>
																		</div>
																		<div className="vw-50 text-right">
																			<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
																				"en-US",
																				{
																					minimumFractionDigits: 2,
																					maximumFractionDigits: 2,
																				}
																			).format(
																				selectedPlan?.basic_premium ||
																					0
																			)}`}</span>
																		</div>
																	</div>

																	{Number(selectedPlan?.all_rider_amount) > 0 && (
																		<div className="d-flex justify-content-between align-items-center pb-2">
																			<div className="vw-50 text-left">
																				<span className="formatted-text">
																					{
																						"All Rider Premium"
																					}
																				</span>
																			</div>
																			<div className="vw-50 text-right">
																				<span className="fw-medium color-heading">{`RM ${new Intl.NumberFormat(
																					"en-US",
																					{
																						minimumFractionDigits: 2,
																						maximumFractionDigits: 2,
																					}
																				).format(
																					Number(
																						selectedPlan?.all_rider_amount
																					) || 0
																				)}`}
																				</span>
																			</div>
																		</div>
																	)}

																	<div className="d-flex justify-content-between align-items-center pb-2">
																		<div className="vw-50 text-left">
																			<span className="formatted-text">{`No Claim Discount (${parseFloat(
																				selectedPlan?.ncd_percent ||
																					0
																			)}%)`}</span>
																		</div>
																		<div className="vw-50 text-right">
																			<span className="fw-medium color-heading">{`- RM ${new Intl.NumberFormat(
																				"en-US",
																				{
																					minimumFractionDigits: 2,
																					maximumFractionDigits: 2,
																				}
																			).format(
																				selectedPlan?.ncd_amount ||
																					0
																			)}`}</span>
																		</div>
																	</div>
																</div>

																{addOnPrices &&
																	addOnPrices.length >
																		0 && (
																		<div className="col-lg-6 text-left">
																			<h4>
																				Add-Ons
																			</h4>
																			<hr />
																			{addOnPrices.map(
																				(
																					add_ons,
																					index
																				) => (
																					<div className="d-flex justify-content-between align-items-center pb-2">
																						<div className={`vw-50 col-sm-6 text-left`}>
																							<span className="formatted-text">
																								{add_ons.description ? decodeURIComponent(add_ons.description) : getAddOnDescription(add_ons.code)}
																							</span>
																						</div>
																						<div className={`vw-50 col-sm-6 text-right`} >
																							<span className="fw-medium color-heading">
																								{`RM ${new Intl.NumberFormat("en-US",
																											{
																												minimumFractionDigits: 2,
																												maximumFractionDigits: 2,
																											}
																									).format(
																											add_ons.amount ||
																												0
																									)}`
																								}
																							</span>
																						</div>
																					</div>
																				)
																			)}
																		</div>
																	)}

																<div className="d-flex justify-content-between align-items-center pb-2">
																	<div className="vw-50 text-left">
																		<span className="fw-bold color-heading">
																			{t(`autoInsurance.addOns.grossPremium`)}
																		</span>
																	</div>
																	<div className="vw-50 text-right">
																		<span className="fw-bold color-heading">
																			{`RM ${
																				new Intl.NumberFormat("en-US", {
																					minimumFractionDigits: 2,
																					maximumFractionDigits: 2,
																				}).format(
																					selectedPlan?.gross_premium || 0
																					)
																				}`
																			}
																		</span>
																	</div>
																</div>
															</div>
														)}
													</div>
													<Button
														label="Proceed (3/5)"
														loading={loading || quoteLoading || effectLoading}
														onClick={(e) =>
															handleProceedButton(
																e
															)
														}
														className="btn-primary"
													/>
												</div>
											</>
										)}
									></Dialog>
								</div>
								{selectedPlan && (
									<div
										className={`sticky-bottom ${
											isModalVisible ? "hidden" : ""
										}`}
									>
										<div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
											{/* Selected Plan and Logo Section */}
											<div className="plan-details w-50">
												<span className="text-left formatted-text">
													Selected Plan for
												</span>
												<p className="my-0 fw-bold insurer-name">
													{getInsurerName(selectedPlan.insurer_name)}
												</p>
											</div>
											<div className="col-sm-6 w-50">
												<Image
													width="100%"
													height="auto"
													src={selectedPlan.image_url}
													alt={
														selectedPlan.insurer_name
													}
													style={{
														maxWidth: [
															"GENERALI",
															"BERJAYA SOMPO",
															"TOKIO MARINE",
															"TUNE PROTECT",
															"TAKAFUL IKHLAS",
														].includes(
															selectedPlan.insurer_name
														)
															? "100px"
															: "150px",
														height: "auto",
														display: "block",
														margin: "0 auto",
													}}
												/>
											</div>
										</div>
										<hr />
										<div className="d-flex flex-row flex-wrap justify-content-between align-items-center py-2">
											{/* Total Price Section */}
											<div className="w-50">
												<span className="fs-xl fw-bold">
													{`RM ${
														new Intl.NumberFormat("en-US", {
															minimumFractionDigits: 2,
															maximumFractionDigits: 2,
														}).format(
															selectedPlan?.gross_premium || 0
															)
														}`
													}
												</span>
											</div>
											<div className="w-50 text-right">
												<span
													className="fw-bold color-primary view-details-link"
													onClick={() =>
														setIsModalVisible(true)
													}
												>
													View Details
												</span>
											</div>
										</div>
										<Button
											label="Proceed (3/5)"
											loading={loading || quoteLoading || effectLoading}
											onClick={(e) =>
												handleProceedButton(e)
											}
											className="btn-primary"
										/>
										{/* BottomMessagePopUp Component */}
										<BottomMessagePopUp
											message={errorMessage}
											type="error"
											isVisible={isErrorVisible}
											onClose={() =>
												setIsErrorVisible(false)
											}
										/>
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default InsuranceAddOns;
